import React, { useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { FaEye, FaEyeSlash, FaLock, FaEnvelope } from 'react-icons/fa';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import './Home.css';
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


 const handleLogin = async () => {
  setLoading(true); // Start loading
  try {
    const response = await axios.post('https://backend.aubattle.com/api/auth/login', { email, password });
    
    if (response.data.token && response.data.user_id && response.data.role) {
      const tokenExpiry = Date.now() + 9 * 24 * 60 * 60 * 1000;

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user_id', response.data.user_id);
      localStorage.setItem('role', response.data.role);
      localStorage.setItem('token_expiry', tokenExpiry);

      console.log("✅ Login Success: ", response.data);

      if (response.data.role === "admin") {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    } else {
      setError("Invalid response from server.");
    }
  } catch (err) {
    setError('Email or password incorrect');
  } finally {
    setLoading(false); // Stop loading
  }
};


  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const response = await axios.post('https://backend.aubattle.com/api/auth/google-auth', {
        tokenId: credentialResponse.credential,
      });

      if (response.data.token && response.data.user_id && response.data.role) {  
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user_id', response.data.user_id);
        localStorage.setItem('role', response.data.role);  // ✅ Role store karna zaroori hai!

        console.log("✅ Google Login Success: ", response.data);

        // ✅ Role ke basis par redirect
        if (response.data.role === "admin") {
          navigate('/admin');
        } else {
          navigate('/dashboard');
        }
      } else {
        console.error("Invalid response from server.");
      }
    } catch (error) {
      console.error('Google Sign-In Failed', error);
    }
  };

  return (
    <GoogleOAuthProvider clientId="435743230987-lj3212qf43ua8lg2a96qhckobm32q46k.apps.googleusercontent.com">
      <div className="auth-container">
        <div className="auth-glass-card">
          <div className="auth-header">
            <h1>Welcome Back</h1>
            <p>Login to your account to continue</p>
          </div>

          <div className="auth-form">
            <div className="input-group">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="input-group">
              <FaLock className="input-icon" />
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button
              className="auth-primary-btn"
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? <div className="auth-spinner"></div> : 'Login'}
            </button>

            <div className="auth-social">
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => setError('Google login failed')}
                theme="filled_blue"
                size="large"
                text="continue_with"
                shape="pill"
              />
            </div>

            <div className="auth-footer">
              <Link to="/forget-password" className="auth-link">Forgot Password?</Link>
              <span>Don't have an account? <Link to="/signup" className="auth-link">Sign Up</Link></span>
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Login;
